import { ArrayUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutSettlementList } from "./autogen/AutogenLayoutSettlementList";
import { DataSourceExecutionEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { DataLoadActionHandler } from "@mcleod/common";

export class SettlementList extends AutogenLayoutSettlementList {
    onLoad(): void | Promise<void> {
        this.tableSettlements.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const labelOriginState = tableRow.findComponentById("labelOriginState") as Label;
            if (labelOriginState != null && !tableRow.data.isNull("origin_state")) {
                labelOriginState.text = ", " + tableRow.data.get("origin_state");
            }

            const labelDestinationState = tableRow.findComponentById("labelDestinationState") as Label;
            if (labelDestinationState != null && !tableRow.data.isNull("destination_state")) {
                labelDestinationState.text = ", " + tableRow.data.get("destination_state");
            }
        });
    }

    sourceSettlementAfterExecution(event: DataSourceExecutionEvent) {
        this.handleDataLoadActions();
    }

    handleDataLoadActions() {
        const props = UrlUtil.getPropsFromUrl(window.location.href);
        if (props != null) {
            const dataLoadActionProps = DataLoadActionHandler.gatherFromUrlProps(props);
            if (ArrayUtil.isEmptyArray(dataLoadActionProps) === false) {
                DataLoadActionHandler.handleDataLoadActions(this, dataLoadActionProps, props);
            }
        }
    }
    
}
